import { intl } from '@approvalmax/utils';
import { LineItemFooterLine } from 'pages/requestForm/components/lineItemsSection/LineItemFooterLine/LineItemFooterLine';
import { FC } from 'react';

import { messages } from './XeroCisDeductionLine.messages';
import { XeroCisDeductionLineProps } from './XeroCisDeductionLine.types';

/**
 * @deprecated Old design
 */
const XeroCisDeductionLine: FC<XeroCisDeductionLineProps> = (props) => {
    const { cisTaxAmount, cisRate, currency } = props;

    return (
        <LineItemFooterLine
            label={messages.cisTaxAmount({
                percent: cisRate,
            })}
        >
            {intl.formatCurrency(cisTaxAmount, currency)}
        </LineItemFooterLine>
    );
};

export default XeroCisDeductionLine;
